module.exports = __webpack_public_path__ + "static/media/kofi.96681ac5.png";